export default "__VITE_ASSET__Cl377BaS__"